module.exports = __webpack_public_path__ + "img/edits-is-savings.ea0fdd8c.svg";